import { useState } from 'react';

type PaginationData<T> = {
  paginatedData: T[];
  hasMoreItems: boolean;
  shownItemsCount: number;
  showMore: () => void;
};

export default function<T>(data: T[], itemsPerPage: number): PaginationData<T> {
  if (itemsPerPage === 0) {
    return {
      paginatedData: data,
      hasMoreItems: false,
      showMore: () => {},
      shownItemsCount: data.length,
    };
  }

  const [shownItemsCount, setShownItemsCount] = useState(itemsPerPage);

  const showMore = (): void => {
    setShownItemsCount((prevCount): number => prevCount + itemsPerPage);
  };

  const paginatedData = data.slice(0, shownItemsCount);
  const hasMoreItems = shownItemsCount < data.length;

  return {
    paginatedData,
    hasMoreItems,
    showMore,
    shownItemsCount,
  };
}
